import { assertUnreachable } from './assertUnreachable';

/**
 * It takes a post and returns the router path to that post
 * @param locale
 * @param type
 * @param card
 * @returns The path to the post.
 */
export function getContentHubPath(locale = 'de', type: string, slug: string) {
  switch (type) {
    case 'artikel':
      return `/${locale}/artikel/${slug}/`;
    case 'flash-talk':
      return `/${locale}/flash-talk/${slug}/`;
    case 'edu-talk':
      return `/${locale}/edu-talk/${slug}/`;
    case 'podcast':
      return `/${locale}/podcast/${slug}/`;
    case 'ratgeber':
      return `/${locale}/ratgeber/${slug}/`;
    case 'webinar':
      return `/${locale}/webinar/${slug}/`;
    case 'news':
      return `/${locale}/news/${slug}/`;
    case 'page':
      return `/${locale}/${slug}/`;
    default:
      return assertUnreachable(type as never);
  }
}
